import React, { useEffect, useState } from 'react'
import { IonAvatar, IonicSlides, IonBackButton, IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonItemDivider, IonLabel, IonList, IonModal, IonNote, IonPage, IonRadio, IonRadioGroup, IonSelect, IonSelectOption, IonTitle, IonToolbar, IonChip, IonRow, IonCol, IonAccordion, IonAccordionGroup, IonText, IonAlert } from '@ionic/react'
import { SafetyPadding } from '../../components/SafetyPadding'
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import Api from "../../services/Api"
import { arrowBack, arrowForward, close, pencil, person } from 'ionicons/icons';
import { Navigation, Pagination, Scrollbar,  } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';

import 'swiper/scss'
import 'swiper/scss/navigation'
import 'swiper/scss/pagination'
import dayjs from 'dayjs';

interface TeamInterface {
  teamId: number,
  teamKey: string,
  teamMembers: Array<any>,
  teamName: string
}

interface MemberInterface {
  checked: boolean,
  firstName: string,
  friendId: number
  name: string
  picture: string
}

interface ChallengeInterface {
  team_group_id: string,
  name: string | null | undefined,
  start: string,
  end: string,
  route_id: number,
  team_members: Array<MemberInterface>
}

const CreateChallenge = () => {
  const api = Api.getInstance()
  const teams = useSelector((state: RootState) => state.logIn.user.teams)
  const myself = useSelector((state: RootState)=> state.logIn.user.person)
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass>({} as SwiperClass) ;
  const [teamModal, setTeamModal] = useState(false)
  const [inputEdit, setInputEdit] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [sliderOpen, setSliderOpen] = useState(false)
  const [status, setStatus] = useState(false)
  const [pickedTeam, setPickedTeam] = useState<TeamInterface>({
    teamId: 0,
    teamKey: '',
    teamMembers: [],
    teamName: ''
  })
  const [challengeInput, setChallengeInput] = useState<ChallengeInterface>({
    team_group_id: '',
    name: 'Sverige runt',
    start: '',
    end: '',
    route_id: 3,
    team_members: []
  })

  useEffect(() => {
    console.log(pickedTeam)
  }, [pickedTeam])

  useEffect(() => {
    if(filterTeams()[0] !== undefined){
      setPickedTeam(filterTeams()[0])
      console.log(filterTeams())
    }
  }, [challengeInput.team_group_id])

  const filterTeams = () => {
    return teams.filter((team: any) => team.teamId === challengeInput.team_group_id)
  }
  const inputChange = (e:any) => {
    setChallengeInput({
      ...challengeInput,
      [e.target.id]: e.target.value
    })
  }

  const submitForm = () => {
    const request = {
      name: challengeInput.name,
      start: challengeInput.start,
      end: challengeInput.end,
      team_members: challengeInput.team_members,
      route_id: challengeInput.route_id
    }
    request.team_members.push({
      checked: true,
      name: myself.firstName,
      firstName: myself.firstName,
      friendId: myself.id,
      picture: myself.picture
    })

    api.post('pedometer/create_challenge/' + challengeInput.team_group_id + '/' + 0 + '/' + challengeInput.route_id, request).then(res => {
      res.json().then(data => {
        if(data.status === 'ok') {
          swiperInstance.slideNext()
          setStatus(true)
        } else {
          setStatus(false)
          setIsOpen(true)
        }
      }).catch(e => {
        setStatus(false)
        setIsOpen(true)
      })
    })
  }

  const clearChecked = () => {
    const people = pickedTeam.teamMembers.map(person => {
      return {
        ...person,
        checked: false,
        firstName: person.firstName,
        friendId: person.friendId,
        name: person.name,
        picture: person.picture
      }
    })
    setPickedTeam({
      ...pickedTeam,
      teamMembers: people
    })
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton/>
          </IonButtons>
          <IonTitle>Skapa utmaning</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard className="p-2 m-2" onClick={() => setSliderOpen(true)}>
          <IonCardHeader>
            <IonCardTitle>Sverige runt</IonCardTitle>
            <IonCardSubtitle>
              <IonChip color="darkblue" className="m-2 p-2">5423 km</IonChip>
              <IonChip color="darkblue" className="m-2 p-2">6 weeks</IonChip>
              {/* <IonChip color="darkblue" className="m-2 p-2">
                <IonIcon icon={person}/>
                  3-11 
                </IonChip> */}
            </IonCardSubtitle>
          </IonCardHeader>
          <IonCardContent className="mt-2">
            Håll aktiviten uppe, anta en utmaning som grupp och ta er runt Sverige på 6 veckor.
          </IonCardContent>
        </IonCard>
      </IonContent>
      <SafetyPadding/>
      <IonModal isOpen={sliderOpen} className="modal_centered">
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => {
                  if(swiperInstance.activeIndex === 0) {
                    setSliderOpen(false)
                  } else {
                    swiperInstance.slidePrev()
                  }
                }}>
                <IonIcon icon={arrowBack}/>
              </IonButton>
            </IonButtons>
            <IonTitle></IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => {
                swiperInstance.slideNext()
              }}>
                <IonIcon icon={arrowForward}/>
              </IonButton>
              <IonButton onClick={() => setSliderOpen(false)}>
                Stäng
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <Swiper
            className="mySwiper"
            modules={[Navigation, Pagination, Scrollbar, IonicSlides]} 
            pagination={{ type: 'progressbar' }}
            slidesPerView={1}
            onSwiper={(swiper) => setSwiperInstance(swiper)}>
            <SwiperSlide>
              <IonContent>
                <h2 className="text_center color_blue m-4">Välj deltagare</h2>
                <IonRow>
                  <IonCol size="2" className="flex justify-center items-center">
                    <div className="circle_medium background_blue flex justify-center items-center">1</div>
                  </IonCol>
                  <IonCol>
                    <IonItem>
                      <IonLabel slot="start">Välj nätverk</IonLabel>
                      <IonSelect 
                        slot="end"
                        onIonChange={(e) => inputChange(e)}
                        id="team_group_id"
                        value={challengeInput.team_group_id} 
                        mode="ios" 
                        interface="action-sheet" 
                        placeholder="Välj nätverk">
                        {teams.map((team: any) => <IonSelectOption value={team.teamId}>{team.teamName}</IonSelectOption>)}
                      </IonSelect>
                    </IonItem>
                  </IonCol>
                </IonRow>
                { challengeInput.team_group_id === '' ? null : <div>
                <IonRow>
                  <IonCol size="2" className="flex justify-center items-center">
                    <div className="circle_medium background_blue flex justify-center items-center">2</div>
                  </IonCol>
                  <IonCol>
                    <IonItem className="fullWidth">
                      <IonLabel>Välj deltagare</IonLabel>
                    </IonItem>
                  </IonCol>
                </IonRow>
                <IonItemDivider color="darkblue" className="m-2 p-2">
                  <IonLabel>Deltagare</IonLabel>
                  <IonButton 
                    onClick={() => clearChecked()}
                    slot="end" 
                    size="small" 
                    color="primary">Rensa</IonButton>
                </IonItemDivider>
                { challengeInput.team_group_id !== '0' ? <IonList>
                    { pickedTeam.teamMembers.map(person => {
                      return <IonItem>
                        <IonAvatar>
                          <img src={person.picture} alt=""/>
                        </IonAvatar>
                        <IonLabel className="ml-2">{person.name}</IonLabel>
                        <IonCheckbox 
                          slot="end" 
                          checked={person.checked} 
                          onIonChange={(e) => {
                            const memberToggle = pickedTeam.teamMembers.map((member: MemberInterface) => {
                              let teamMemberToggled = member
                              if(person.friendId === member.friendId) {
                                teamMemberToggled.checked = e.detail.checked
                              } else {

                              }
                              return teamMemberToggled
                            })
                            setPickedTeam({ ...pickedTeam, teamMembers: memberToggle})
                          }}/>
                      </IonItem>})
                    }
                  </IonList> 
                : null }
                <IonButton 
                  className="m-2" 
                  expand="block"
                  onClick={() => {
                    const pickedMembers = pickedTeam.teamMembers.filter(member => {
                      if(member.checked === true){
                        return member
                      } else {
                        return null
                      }
                    })
                    // console.log(pickedMembers)
                    setChallengeInput({...challengeInput, team_members: pickedMembers })
                    swiperInstance.slideNext()
                  }}
                >Välj & gå vidare</IonButton>
                </div> }
                <SafetyPadding/>
              </IonContent>
            </SwiperSlide>
            <SwiperSlide>
              <IonContent>
                <h2 className="text_center color_blue m-4">Välj start datum</h2>
                <IonItem lines='full'>
                  <IonInput
                    onIonChange={(e) => inputChange(e)}
                    id="start"
                    placeholder="Start" 
                    type="text" 
                    value={challengeInput.start}>
                    <IonLabel>Start</IonLabel>
                  </IonInput>
                </IonItem>
                <IonNote className="ml-2 flex justify-end">T.ex '2023-10-03'</IonNote>
                <IonButton 
                  className="m-2"
                  expand='block'
                  onClick={() => {
                    dayjs(challengeInput.start).add(6, 'weeks')
                    swiperInstance.slideNext()
                    setChallengeInput({
                      ...challengeInput,
                      end: dayjs(challengeInput.start).add(6, 'weeks').format('YYYY-MM-DD')
                    })
                  }}>Gå vidare</IonButton>
              </IonContent>
            </SwiperSlide>
            <SwiperSlide>
              <h2 className="text_center color_blue m-4">Preview challenge</h2>
              <IonCard className="m-2 p-2">
                <IonCardHeader>
                  <IonItem lines='none'>
                    <IonCardTitle>
                      <IonInput 
                        type="text" 
                        value={challengeInput.name}
                        onIonChange={(e) => {
                          setChallengeInput({
                            ...challengeInput,
                            name: e.detail.value
                          })
                        }}/>
                    </IonCardTitle>
                  </IonItem>
                  <IonCardSubtitle>
                    <IonChip color="darkblue" className="m-2 p-2">5423 km</IonChip>
                    <IonChip color="darkblue" className="m-2 p-2">6 weeks</IonChip>
                    {/* <IonChip color="darkblue" className="m-2 p-2">
                    <IonIcon icon={person}/>
                      3-11 
                    </IonChip> */}
                  </IonCardSubtitle>
                </IonCardHeader>
                <IonCardContent>
                  <IonList>
                    <IonItem>
                      <IonLabel>Start</IonLabel>
                      <IonText>{challengeInput.start}</IonText>
                    </IonItem>
                    <IonAccordionGroup>
                      <IonAccordion value="first">
                        <IonItem slot="header">
                          <IonLabel>Medlemmar</IonLabel>
                        </IonItem>
                        <div slot="content">
                          {challengeInput.team_members.map(member => <IonItem>
                            <IonAvatar>
                              <img src={member.picture} alt="challengemembers"/>
                            </IonAvatar>
                            <IonLabel className="ml-2">{member.firstName}</IonLabel>
                          </IonItem>)}
                        </div>
                      </IonAccordion>
                    </IonAccordionGroup>
                  </IonList>
                </IonCardContent>
              </IonCard>
              <IonButton 
                expand='block'
                className="m-2"
                onClick={() => {
                  submitForm()
                }}>Skapa utmaning</IonButton>
            </SwiperSlide>
            <SwiperSlide>
              { status ? 
                <h2 className="text_center color_blue m-4">Success, utmaningen har skapats</h2>
              :
                <h2 className="text_center color_blue m-4">Något gick fel</h2>
              }
            </SwiperSlide>
          </Swiper>
        </IonContent>
      </IonModal>
      <IonAlert
        isOpen={isOpen}
        header="Alert"
        subHeader="Någonting gick fel"
        message="Kontrollera din utmaning, eller försök igen."
        buttons={['OK']}
        onDidDismiss={() => setIsOpen(false)}
      />
    </IonPage>
  )
}
export default CreateChallenge
